import script from "./EmailConfirmComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailConfirmComponent.vue?vue&type=script&setup=true&lang=ts"

import "./EmailConfirmComponent.vue?vue&type=style&index=0&id=32d21ecc&lang=css"

const __exports__ = script;

export default __exports__